import React from "react";
import { usePaginationFragment } from "react-relay/hooks";
import { graphql } from "babel-plugin-relay/macro";
import { ClassesTableFragment$key } from "./__generated__/ClassesTableFragment.graphql";
import styles from "./ClassesTable.module.scss";
import { useNavigate } from "react-router-dom";

type Props = {
  initialQueryRef: ClassesTableFragment$key;
};

const ClassesTable = ({ initialQueryRef }: Props) => {
  const { data } = usePaginationFragment(
    graphql`
      fragment ClassesTableFragment on Query
      @refetchable(queryName: "ClassesTableFragment") {
        school(id: $school) {
          id
          classes(after: $after, first: $first)
            @connection(key: "ClassesTableFragment_classes") {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
    `,
    initialQueryRef
  );

  const navigate = useNavigate();

  return (
    <div className={styles.classesTableWrapper}>
      <table className={styles.classesTable}>
        <thead>
          <tr>
            <th></th>
            <th>Name</th>
            <th>ID</th>
          </tr>
        </thead>
        <tbody>
          {data.school?.classes?.edges.map((edge) => {
            return (
              <tr
                onClick={() => {
                  navigate(
                    `/schools/${data.school.id}/classes/${edge.node.id}`
                  );
                }}
                key={edge.node.id}
              >
                <td>
                  {/*edge.node.debug && <span className={styles.badge + " " + styles.blue}><Trans i18nKey={"rooms.debug"}>Debug</Trans></span>}
                            {!edge.node.active && <span className={styles.badge + " " + styles.red}><Trans i18nKey={"rooms.inactive"}>Inactive</Trans></span>}
                            {edge.node.active && <span className={styles.badge + " " + styles.green}><Trans i18nKey={"rooms.active"}>Active</Trans></span>*/}
                </td>
                <td>{edge.node.name}</td>
                <td>{edge.node.id}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ClassesTable;
